export interface DataCardValue {
    label?: string;
    value?: number | string;
}

export interface DataCardProps {
    title: string;
    data?: number | string | DataCardValue[];
    unit?: string;
    color?: string;
    titleBgColor?: string;
    tooltipContent?: string;
}

/** 数据统计卡片，保留旧版标题、数值/单位分组及提示文案契约。 */
export function DataCard({
    title,
    data,
    unit,
    color = "#3370ff",
    titleBgColor = "#f3f8ff",
    tooltipContent
}: DataCardProps) {
    const valueList: DataCardValue[] = Array.isArray(data) ? data : [{ label: unit, value: data }];
    return (
        <div
            className="data-card-container"
            style={{ "--data-card-color": color, "--data-card-title-bg": titleBgColor } as React.CSSProperties}
            title={tooltipContent}
        >
            <div className="title">{title}</div>
            <div className="data-content">
                {valueList.map((item, index) => (
                    <span key={`${item.label || "value"}-${index}`}>
                        {item.value !== undefined && item.value !== "" ? (
                            <span className="num">{item.value}</span>
                        ) : null}
                        {item.label ? <span className="unit">{item.label}</span> : null}
                    </span>
                ))}
            </div>
        </div>
    );
}

export default DataCard;
